import { render, staticRenderFns } from "./DoNotArbsModal.vue?vue&type=template&id=23e6419c&"
import script from "./DoNotArbsModal.vue?vue&type=script&lang=js&"
export * from "./DoNotArbsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports